import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import TanzaniaSpecialistLogo from 'assets/TZ-logo.png';
import AfricaSafariLogo from 'assets/AS-logo.png';
import TripImage from 'assets/default-trip-image.png';
import Footer from 'components/Footer';

import { AFRICA_SAFARI_DARK_LOGOS, TANZANIA_SPECIALIST_DARK_LOGOS } from 'utils/constants';

import './styles.css';

export interface IAuthPage {
  children: React.ReactNode;
}

const AuthPage = ({ children }: IAuthPage) => {
  const { i18n } = useTranslation();

  const tanzaniaSpecialistLogo = useMemo(() => {
    return _.get(TANZANIA_SPECIALIST_DARK_LOGOS, i18n.language);
  }, [i18n.language]);

  const africaSafariLogo = useMemo(() => {
    return _.get(AFRICA_SAFARI_DARK_LOGOS, i18n.language);
  }, [i18n.language]);

  return (
    <div className='flex flex-col justify-center min-h-screen'>
      {/* large screens top header */}
      <div className='hidden md:flex auth-page-layout pt-9 justify-center h-[220px]'>
        <div className='flex h-[66px] gap-6'>
          <img src={tanzaniaSpecialistLogo} width={200} />
          <img src={africaSafariLogo} width={142} />
        </div>
      </div>
      {/* end large screens top header */}
      {/* small screens top header */}
      <div className='md:hidden flex justify-center pt-[50px] auth-page-mobile-layout h-[150px]'>
        <div>
          <div className='flex justify-center gap-6 mb-[20px] h-[40px]'>
            <img src={TanzaniaSpecialistLogo} />
            <img src={AfricaSafariLogo} />
          </div>
        </div>
      </div>
      {/* end small screens top header */}

      <div className='self-center flex gap-[80px] flex-col p-[16px] lg:p-0 w-full lg:w-5xl max-w-[500px] lg:max-w-[1050px] lg:flex-row mt-[50px] md:mt-0'>
        <img src={TripImage} width={456} className='hidden lg:block' />
        {children}
      </div>
      <Footer className='mt-auto' />
    </div>
  );
};

export default AuthPage;
